import React, { createRef } from "react";
import fieldPropTypes from "./field-prop-types";
import { fieldValidation as validation } from "../utils/field-validation";
import ValidationMessage from "../theme/default/validation-message";
import Label from "../theme/default/label";
import Text from "../theme/default/text";

class FormImage extends React.Component {
  static updateControlValidation(field, appData, value) {
    validation[field.type].update(field, appData, value);
  }

  constructor(props) {
    super(props);
    this.wrapperRef = createRef();
    const { field, appData } = props;
    this.inputOpenFileRef = React.createRef();
    FormImage.updateControlValidation(field, appData, {
      fieldRef: this.wrapperRef
    });
    this.state = {
      invalidSize: false,
      chosenValueTitle: appData.settings.translations.no_file_chosen
    };
  }

  componentDidUpdate() {
    const { field, appData } = this.props;
    FormImage.updateControlValidation(field, appData, {
      fieldRef: this.wrapperRef
    });
    appData.screenRefs = {
      ...appData.screenRefs,
      inputFileRef: this.inputOpenFileRef
    };
  }

  componentWillUnmount() {
    delete this.props?.appData?.screenRefs?.inputFileRef;
  }

  isInvalid() {
    const { name } = this.props.field;
    const { fieldValidation } = this.props.appData;
    return fieldValidation[name] && !fieldValidation[name].isValid;
  }

  render() {
    const {
      field: { name },
      appData: {
        values,
        fieldValidation,
        resetFieldValidation,
        handleFileInputChange,
        settings
      }
    } = this.props;
    const { errorMessage } = fieldValidation[name] || {};

    this.getSizeValidation = e => {
      const file = e.target.files[0];

      if (file.size > 15728640) {
        this.setState({
          invalidSize: true
        });
      } else {
        this.setState({
          invalidSize: false
        });
      }
    };

    this.setFileValueTitle = e => {
      const value =
        this.props.appData.settings.translations.file_name_have_been_attached.replace(
          "%file_name%",
          e.target.files[0].name
        );

      this.setState({
        chosenValueTitle: value
      });
    };

    return (
      <div className='field-wrapper-web-sdk' ref={this.wrapperRef}>
        {values[name] ? (
          <img
            className='photo-preview-image-500'
            src={values[name].thumbnails["500"]}
            alt='Preview'
          />
        ) : (
          <div>
            <Label
              inputId={`file-input-${name}`}
              size='file-upload'
              text={settings.translations.choose_file}
            />
            <Text
              name='file-upload-description'
              label={settings.translations.no_file_chosen}
              isSpan={true}
            />
          </div>
        )}
        <input
          id={`file-input-${name}`}
          name={`file-input-${name}`}
          data-testid={`file-input-${name}`}
          title={this.state.chosenValueTitle}
          type='file'
          ref={this.inputOpenFileRef}
          style={{ display: "none" }}
          accept='.jpg,.jpeg,.png,.gif,.pdf,.docx,.doc,.xlsx,.xls'
          role='button'
          aria-label={settings.translations.choose_photo}
          onChange={e => {
            this.getSizeValidation(e);
            this.setFileValueTitle(e);
            resetFieldValidation(name);
            if (name.includes(":")) {
              const prefix = name.split(":")[0];
              resetFieldValidation(`${prefix}:photoName`);
              resetFieldValidation(`${prefix}:attachment_type_cd`);
            }
            handleFileInputChange(e, name);
          }}
        />
        {!values[name] ? (
          <p className='websdk-pt-3'>
            {settings.translations.acceptable_file_types}
          </p>
        ) : null}
        <ValidationMessage isInvalid={this.isInvalid()}>
          {errorMessage}
        </ValidationMessage>
        <ValidationMessage isInvalid={this.state.invalidSize}>
          {settings.translations.file_size_limit}
        </ValidationMessage>
      </div>
    );
  }
}

FormImage.propTypes = fieldPropTypes;

export default FormImage;
